var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseActionTimeIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#course_action_time_ic_svg__clip0_873_12131)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#course_action_time_ic_svg__clip1_873_12131)",
    stroke: "#3A3A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.272 12.002a5.002 5.002 0 100-10.005 5.002 5.002 0 000 10.005z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.271 3.998V7l2.001 1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "course_action_time_ic_svg__clip0_873_12131"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 7.636 7.636)",
    d: "M0 0h14v15.273H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "course_action_time_ic_svg__clip1_873_12131"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1.269 .997)",
    d: "M0 0h12.006v12.006H0z"
  })))));
}
export default SvgCourseActionTimeIc;